import type {
  Cryptocurrency,
  SupportedCurrency,
} from '#src/__generated__/globalTypes.ts';
import { Currency } from '#src/__generated__/globalTypes.ts';

export const getCurrenciesFromSettlementCurrenciesWhenCannotSwapCrypto = (
  settlementCurrencies: SupportedCurrency[],
  cryptocurrency: Cryptocurrency
) =>
  settlementCurrencies.reduce<Currency[]>((acc, curr) => {
    if (curr === cryptocurrency) return [...acc, Currency.ETH];
    if (!acc.includes(Currency.FIAT)) return [...acc, Currency.FIAT];
    return acc;
  }, []);
